import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMessageField.scss';

function ErrorMessageField({
  errorMessage,
  showMessage,
}) {
  if (!showMessage) {
    return null;
  }
  return (
    <span className="error-message">
      {errorMessage}
    </span>
  );
}

ErrorMessageField.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  showMessage: PropTypes.bool.isRequired,
};

export default ErrorMessageField;
